import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {IOrderHistoryViewProduct, IOrderHistoryViewProductDisplayAttribute} from "../orders-models";
import {Util} from "../../util/util";
import {OrderHistoryCacheService} from "../order-history/order-history-cache.service";
import {Subscription} from "rxjs";
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {ProductUtil} from '../../util/product-util';

@Component({
    selector: "order-history-product",
    templateUrl: "./order-history-product.component.html",
    styleUrls: ['../orders.scss', './order-history-product.component.scss'],
    standalone: false
})
export class OrderHistoryProductComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() viewProduct: IOrderHistoryViewProduct;
    @Input() displayAttributes: IOrderHistoryViewProductDisplayAttribute[];
    @Input() currencyCode: string;
    @Input() orderId: number;
    @Output() readonly itemAdded = new EventEmitter();

    isAddingToCart: boolean = false;
    subscription: Subscription = new Subscription();

    ProductUtil = ProductUtil;

    constructor(userService: UserService,
                loggerService: LoggerService,
                private orderHistoryCacheService: OrderHistoryCacheService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        // item is being added to cart for this order OR if the full order is being added to cart
        this.subscription.add(this.orderHistoryCacheService.productsAddingSubject.subscribe((productsAddingMap) => {
            this.isAddingToCart = productsAddingMap?.get(this.orderId)?.some((product) => product.id === this.viewProduct.id && product.mhpId === this.viewProduct.mhpId);
        }));
        this.subscription.add(this.orderHistoryCacheService.orderAddingSubject.subscribe((orderId) => {
            this.isAddingToCart = orderId === this.orderId;
        }));
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    setActiveOrderView() {
        const orderViews = this.orderHistoryCacheService.getOrderViews();
        if (orderViews?.length) {
            const selectedOrderView = orderViews.find(orderView => orderView.id === this.orderId);
            if (selectedOrderView) {
                this.orderHistoryCacheService.setActiveOrderView(selectedOrderView);
            }
        }
    }

    trackByFn(index: any) {
        return Util.trackByFn(index);
    }
}
